module.exports = __webpack_public_path__ + "static/ey-1-748c9753eee395a6af5c42838a88f25d.png";